<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Payroll Adjustment</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="grade_number"> <span class="required">*</span> Employee </label>
                        <AsyncSelect
                            :multiple="!isEdit"
                            placeholder="Select Employee"
                            v-model="contactProfile"
                            :api-service="fetchContactProfiles"
                            :additional-query="additionalContactOption"
                        />
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="grade_title"> Pay Head </label>
                        <AsyncSelect
                            placeholder="Select Pay Head"
                            v-model="payHead"
                            :api-service="fetchPayHeadDropdown"
                            :additional-query="{payroll_category: 'adjustment'}"
                        />
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="grade_title"> Amount </label>
                        <input
                            class="form-control invoice-edit-input"
                            tabindex="1"
                            type="text"
                            placeholder=""
                            v-model="formData.pay_head_amount"
                        >
                      </div>
                    </div>

                    <div class="col-6 text-center mb-2 mt-2">
                      <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        Submit
                      </button>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from "@/services/modules/contact";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import handleDropDown from "@/services/modules/dropdowns";

const props = defineProps({
    formData:{
      type:Object,
      default:{}
    },
});

const emit = defineEmits(['submitted']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const {
  createPayrollAdjustment,
  updatePayrollAdjustment
} = handleHrPayroll()
let contactProfile = ref(null)
let payHead = ref(null)
let isEdit = ref(false)
const { fetchContactProfiles } = handleContact();
const { fetchPayHeadDropdown } = handleDropDown();
const additionalContactOption = ref({
  roles: 'employee'
});

const submit = async() => {
    const query = getQuery();
    loading.value = true;
    if (isEdit.value){
      await updateData(query)
      return
    }
    await storeData(query)
}

const storeData = async (query) => {
  let payrollAdjustmentData = {};
  payrollAdjustmentData.company_id = $route.params.companyId;
  payrollAdjustmentData.contact_profile_id = contactProfile.value ? contactProfile.value.map(cp => cp.id) : null;
  payrollAdjustmentData.pay_head_id = payHead.value ? payHead.value.id : null;
  payrollAdjustmentData.pay_head_amount = props.formData.pay_head_amount;
  payrollAdjustmentData.type = props.formData.type;
  payrollAdjustmentData.payroll_master_id = props.formData.payroll_master_id;

  await createPayrollAdjustment(payrollAdjustmentData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("submitted");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const updateData = async (query) => {
  let payrollAdjustmentData = {};
  payrollAdjustmentData.company_id = $route.params.companyId;
  payrollAdjustmentData.id = props.formData.id;
  payrollAdjustmentData.contact_profile_id = contactProfile.value ? contactProfile.value.id : null;
  payrollAdjustmentData.pay_head_id = payHead.value ? payHead.value.id : null;
  payrollAdjustmentData.pay_head_amount = props.formData.pay_head_amount;
  payrollAdjustmentData.payroll_master_id = props.formData.payroll_master_id;
  payrollAdjustmentData.type = props.formData.type;

  await updatePayrollAdjustment(payrollAdjustmentData, payrollAdjustmentData.id, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("submitted");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
  props.formData.contact_profile_id = null;
  props.formData.pay_head_id = null;
  props.formData.pay_head_amount = null;
  $store.state.isModalOpenTwo = false;
}

watch(() => props.formData, (newVal) => {
  if (newVal.contact_profile_id) {
    contactProfile.value = {
      id: newVal.contact_profile_id,
      name: newVal.employee_name
    }
  }
  if (newVal.pay_head_id) {
    payHead.value = {
      id: newVal.pay_head_id,
      name: newVal.pay_head_name
    }
  }
  if (newVal.is_edit){
    isEdit.value = true;
  }
}, { immediate: true, deep: true })

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}
</script>
